import { Link, useParams } from "react-router-dom"
import DashboardSideBar from "../../components/dashboardSidebar"
import Footer from "../../components/footer"
import Header from "../../components/header"
import SideBar from "../../components/sidebar"
import { useState, useEffect } from "react"
import services from "../../services"
import constant from "../../constant"
import useIsMobile from "../../hooks/useIsMobile";
import MobileHeader from "../../components/MobileHeader";

const CarDetails = () => {
    let { id } = useParams();
    const isMobileView = useIsMobile();
    const [carData, setCarData] = useState()
    useEffect(() => {
        getCarDetail(id);
    }, [])
    const getCarDetail = async (id) => {
        try {
            const response = await services.Cars.GET_VENDOR_CAR_ID(id);
            console.log(response)
            setCarData(response.data)
        } catch (error) {
            console.log(error)
        }
    }
    if (isMobileView) {
        if (!carData) {
            return (<main className="mlux" style={{ display: 'grid', placeItems: 'center', minHeight: '100vh' }}><div className="mlux-empty"><div className="ic"><i className="far fa-spinner"></i></div><h4>Loading car…</h4></div></main>);
        }
        const photo = carData.photos?.[0];
        return (
            <>
                <SideBar />
                <main className="mlux mlux-auth">
                    <MobileHeader back="/cars" right={<Link to={`/car/edit/${carData.id}`} className="mlux-avatar"><i className="far fa-pen"></i></Link>} />
                    <div className="mlux-greet" style={{ margin: '8px 4px 2px' }} data-rise="1">
                        <div className="kick">Cab #{carData.id}</div>
                        <div className="nm" style={{ fontSize: 22 }}>{carData.Car?.brand} {carData.Car?.name}</div>
                    </div>
                    <div className="mlux-card mlux-car" data-rise="1">
                        <div className="ph" style={{ height: 200 }}>
                            {photo ? <img src={constant.IMAGE_URL + photo} crossOrigin="anonymous" alt={carData.Car?.name} />
                                : <div style={{ height: '100%', display: 'grid', placeItems: 'center', color: '#94a3b8', fontSize: 42 }}><i className="fas fa-car-side"></i></div>}
                        </div>
                        <div className="bd">
                            <div className="feats" style={{ marginBottom: 0 }}>
                                <span className="feat"><i className="far fa-tag"></i> ₹{carData.Car?.perKmCharge}/km</span>
                                <span className="feat"><i className="far fa-user"></i> {carData.Car?.customerCapacity} seats</span>
                                <span className="feat"><i className="far fa-snowflake"></i> {carData.isAcAvailable ? 'AC' : 'Non-AC'}</span>
                                <span className="feat"><i className="far fa-suitcase-rolling"></i> {carData.isCarrierAvailable ? 'Carrier' : 'No carrier'}</span>
                            </div>
                        </div>
                    </div>
                    <div className="mlux-sec-head"><h3>Details</h3></div>
                    <div className="mlux-card" style={{ padding: '4px 16px' }} data-rise="2">
                        <div className="mlux-kv"><span className="k"><i className="far fa-car"></i> Type</span><span className="v" style={{ textTransform: 'uppercase' }}>{carData.Car?.type || '—'}</span></div>
                        <div className="mlux-kv"><span className="k"><i className="far fa-calendar"></i> Model year</span><span className="v">{carData.year || '—'}</span></div>
                        <div className="mlux-kv"><span className="k"><i className="far fa-id-card"></i> RC number</span><span className="v">{carData.rcNumber || '—'}</span></div>
                    </div>
                    <Link to={`/car/edit/${carData.id}`} className="mlux-btn" style={{ marginTop: 16, textDecoration: 'none' }}><i className="far fa-pen"></i> Edit car</Link>
                </main>
            </>
        );
    }

    return (<>
        <Header />
        <SideBar />
        <main class="main">




            <div class="user-profile py-5">
                <div class="container">
                    <div class="row">
                        <DashboardSideBar />
                        {carData && <div class="col-lg-9">
                            <div class="user-profile-wrapper">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="user-profile-card">
                                            <div class="user-profile-card-header">
                                                <h4 class="user-profile-card-title d-flex align-items-center justify-content-between w-100"><span> Cab Detail #{carData.id}</span> <Link to={`/car/edit/${carData.id}`} className="theme-btn">Edit Details</Link></h4>

                                            </div>
                                            <div class="row">

                                                <div class="col-md-12 mx-auto p-0">
                                                    <div class="booking-form shadow-none">

                                                        <div class="col-md-12 col-lg-12 filter-item cat1 cat2">
                                                            <div class="row align-items-center ">
                                                                <a className="col-md-4 col-12"><div class="taxi-img">
                                                                    <img crossorigin="anonymous" src={constant.IMAGE_URL + carData.photos[0]} width={'350px'} />
                                                                </div></a>
                                                                <div class="taxi-content col-md-7 col-12">
                                                                    <div class="taxi-head">
                                                                        <span> <b className="text-uppercase">{carData.Car.type}</b></span><h4>{carData.Car.brand} {carData.Car.name}</h4>

                                                                    </div>
                                                                    <div class="taxi-feature">
                                                                        <ul>
                                                                            <li><i class="far fa-car-side-bolt"></i> Charges Per KM: <span>{carData.Car.perKmCharge}</span></li>
                                                                            <li><i class="far fa-car-side-bolt"></i> Model: <span>{carData.year}</span></li>
                                                                            <li><i class="far fa-person-seat"></i> Passengers: <span>{carData.Car.customerCapacity}</span></li>
                                                                            <li><i class="far fa-suitcase-rolling"></i> Luggage Carrier: <span><b>{carData.isCarrierAvailable ? 'Yes' : 'No'}</b></span></li>
                                                                            <li><i class="far fa-heat"></i> Air Condition: <span><b>{carData.isAcAvailable ? 'Yes' : 'No'}</b></span></li>

                                                                            <li><i class="far fa-user-pilot"></i> Car Number: <span>{carData.rcNumber}</span></li>
                                                                        </ul>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* <div class="user-profile-card-header mt-5">
                                                            <h4 class="user-profile-card-title">Assigned Driver Details</h4>

                                                        </div>
                                                        {carData?.DriverCar?.User && <div class="team-single-wrapper">
                                                            <div class="row align-items-center">
                                                                <div class="col-lg-4">
                                                                    <div class="team-single-img">
                                                                    <img crossorigin="anonymous" src={constant.IMAGE_URL + carData.DriverCar.User.DriverDetail.photo} width={'350px'} />
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-7">
                                                                    <div class="team-single-content">
                                                                        <div class="team-single-name">
                                                                            <h3>{carData.DriverCar.User.firstName} {carData.DriverCar.User.lastName}</h3>
                                                                            <p>Driving License #{carData.DriverCar.User.DriverDetail.drivingLicenceNumber}</p>
                                                                        </div>
                                                                     
                                                                        <div class="team-single-info">
                                                                            <ul>
                                                                                <li>
                                                                                    <span class="team-single-info-left"><i class="far fa-phone"></i>
                                                                                        Phone:</span>
                                                                                    <span class="team-single-info-right">{carData.DriverCar.User.phoneNumber}</span>
                                                                                </li>
                                                                                <li>
                                                                                    <span class="team-single-info-left"><i class="far fa-envelope"></i>
                                                                                        Email:</span>
                                                                                    <span class="team-single-info-right"><a
                                                                                        
                                                                                        class="__cf_email__"
                                                                                        >{carData.DriverCar.User.email}</a></span>
                                                                                </li>
                                                                                <li>
                                                                                    <span class="team-single-info-left"><i class="far fa-tools"></i>
                                                                                        Aadhar:</span>
                                                                                    <span class="team-single-info-right">{carData.DriverCar.User.DriverDetail.aadharNumber}</span>
                                                                                </li>
                                                                            </ul>
                                                                        </div>
                                                                        <hr />

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>} */}


                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>}
                    </div>
                </div>
            </div>

        </main>
        <Footer />
    </>
    )
}
export default CarDetails